document.addEventListener("DOMContentLoaded", function () {
    console.log("📌 DOM fully loaded. Initializing script...");

    function isValidVariantData() {
        return (
            typeof window.mostPopularVariants !== 'undefined' &&
            Object.keys(window.mostPopularVariants).length > 0 &&
            typeof window.valueLabelVariants !== 'undefined' &&
            Object.keys(window.valueLabelVariants).length > 0
        );
    }

    function updateMostPopularBadges() {
        console.log("🔍 Running updateMostPopularBadges...");

        const optionNodes = document.querySelectorAll(".m-product-option--node");
        if (optionNodes.length === 0) {
            console.warn("⚠️ No product options found.");
            return;
        }

        optionNodes.forEach(optionNode => {
            const optionInput = optionNode.querySelector("input[type='radio'][name='Size'], input[type='radio'][name='Flavor']");
            if (!optionInput) return;

            const optionValue = optionInput.value.trim();
            const otherOptionValues = Array.from(document.querySelectorAll(".m-product-option--node input[type='radio']:checked"))
                .filter(input => input.name !== 'Size' && input.name !== 'Flavor')
                .map(input => input.value.trim())
                .join(" / ");

const variantKey = optionValue;

            const mostPopularValue = window.mostPopularVariants?.[variantKey];
            const valueLabel = window.valueLabelVariants?.[variantKey];

            console.log(`🔑 Variant: ${variantKey} → Most Popular: ${mostPopularValue}, Value Label: ${valueLabel}`);

const label = optionNode.querySelector(".m-product-option--node__label");
if (!label) {
  console.warn("⚠️ Label not found for optionNode:", optionNode);
  return;
}

            // BADGE 1: Most Popular
            if (mostPopularValue) {
                let badge = optionNode.querySelector(".most-popular-badge");
                if (!badge) {
                    badge = document.createElement("span");
                    badge.classList.add("most-popular-badge");
                    if (label) label.appendChild(badge);
                }
                badge.textContent = mostPopularValue;
                badge.style.cssText = "display: inline; visibility: visible; opacity: 1;";
                if (label) label.classList.add("highlight-popular");
            }

            // BADGE 2: Value Label (Best Value)
            if (valueLabel) {
                let valueBadge = optionNode.querySelector(".value-label-badge");
                if (!valueBadge) {
                    valueBadge = document.createElement("span");
                    valueBadge.classList.add("value-label-badge");
                    if (label) label.appendChild(valueBadge);
                }
                valueBadge.textContent = valueLabel;
                valueBadge.style.cssText = "display: inline; visibility: visible; opacity: 1;";
            }
        });
    }

    function waitForMostPopularData(callback, retries = 10, delay = 500) {
        let attempts = 0;
        const checkData = setInterval(() => {
            if (isValidVariantData()) {
                clearInterval(checkData);
                console.log("✅ Variant metafields are now available.");
                callback();
            }
            if (++attempts >= retries) {
                clearInterval(checkData);
                console.error("❌ Timed out waiting for variant metafields.");
            }
        }, delay);
    }

    waitForMostPopularData(updateMostPopularBadges);

    const observer = new MutationObserver((mutations, obs) => {
        console.log("🔄 Detected changes in the DOM. Updating badges...");
        obs.disconnect();
        updateMostPopularBadges();
        obs.observe(document.body, { childList: true, subtree: true });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
